import { cn } from '@/lib/utils';

/**
 * A placeholder shaped like the content being loaded (13/10/2026): a page waits
 * with the outline of what comes, never with a « Chargement… » line that is then
 * replaced by a different layout.
 */
export const Skeleton = ({ className }: { className?: string }) => (
  <div aria-hidden className={cn('animate-pulse rounded-lg bg-domino-muted', className)} />
);

/** Screen readers hear one status instead of the shapes. */
export const SkeletonGroup = ({ label, className, children }: { label: string; className?: string; children: React.ReactNode }) => (
  <div role="status" aria-label={label} aria-busy="true" className={className}>{children}</div>
);
